import { Directive, Input, OnInit } from '@angular/core';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { NgControl } from '@angular/forms';
import { filter } from 'rxjs';

/**
 * Directive to transform empty strings to a default value in Angular form inputs.
 *
 * This directive addresses the issue of empty strings being used to represent empty values
 * in Angular forms. This directive allows the use of a default value to be used by the input field.
 *
 * @usage Applied to input elements within Angular forms to automatically convert
 *        empty strings to a default value.
 *
 * @example the default value is null:
 * <input formControlName="fieldName" [ts-empty-string-to-default]="null">
 */

@Directive({
  selector: 'input[ts-empty-default]',
})
export class TsEmptyDefaultDirective extends OnDestroyMixin implements OnInit {
  @Input('ts-empty-default') defaultEmptyValue: unknown;

  constructor(private ngControl: NgControl) {
    super();
  }

  ngOnInit() {
    this.ngControl.control.valueChanges
      .pipe(
        filter((value) => value === ''),
        untilComponentDestroyed(this),
      )
      .subscribe((value) => {
        this.ngControl.control.setValue(this.defaultEmptyValue, { emitEvent: false });
      });
  }
}
